package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.selection.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.template.product_categories.TemplateCategoryModel
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.components.dialog.component.DialogTitle

@Composable
fun AddNewProductSetDialog(
    title: String,
    loading: Boolean,
    templateCategories: List<TemplateCategoryModel>?,
    onDismissDialog: () -> Unit,
    addNewProductSets:(String)->Unit,
)
{
    val selectedCategory= remember {
        mutableStateOf<TemplateCategoryModel?>(null)
    }

    Box(
        modifier = Modifier
            .backgroundDialog()
            .onClick {
                onDismissDialog()
            }
    )
    {
        Column(
            modifier = Modifier
                .onClick {
                    event: SyntheticMouseEvent -> event.stopPropagation()
                }
                .align(Alignment.Center)
                .backgroundColor(Theme.White.rgb)
                .zIndex(1)
                .boxShadow(
                    color = Theme.ActionDisabledBackground.rgb,
                    blurRadius = Dimen.smallBlurRadius,
                )
                .borderRadius(r= Dimen.semiLargeRadius),
            horizontalAlignment = Alignment.Start
        ){

            DialogTitle(
                title = title,
                showCloseIcon = true,
                showSeparator = false,
                onCloseClick = {
                    onDismissDialog()
                },
            )

            Column(
                Modifier
                    .fillMaxWidth()
                    .padding(
                        leftRight = Dimen.extraLargePadding,
                        bottom = Dimen.extraLargePadding,
                    )
            )
            {
                DropDownItem(
                    modifier = Modifier
                        .margin(bottom = Dimen.highLargePadding),
                    options =templateCategories?:listOf(),
                    fillMaxWidth =true,
                    label = Strings.current().template,
                    itemWidth = Dimen.semiLargeEditTextWidth,
                    selectedItem =selectedCategory.value,
                    displayText = {
                        if (it is TemplateCategoryModel)
                            it.name?:""
                        else ""
                    },
                    onOptionClick = {
                         if (it is TemplateCategoryModel)
                             selectedCategory.value=it
                    },
                )



                CustomButton(
                    modifier = Modifier
                        .fillMaxWidth(),
                    buttonType = ButtonTypes.CONTAINED,
                    title = Strings.current().submit,
                    loading =loading ,
                    isClickable =selectedCategory.value!=null,
                    onButtonClick = {
                        addNewProductSets(selectedCategory.value?.id?:"")
                    }
                )


            }


        }



    }




}